const settingsPageNotificationSettingsSectionCopy = {
  errorMessageUpdateNotificationSettingsFailed:
    'Your notification settings were not saved.',
  sectionTitle: 'Notification Settings',
  successMessageUpdatedNotificationSettings:
    'Your notification settings have been updated.'
};

export default settingsPageNotificationSettingsSectionCopy;
